<div class="col-md-12">
    <mat-dialog-content class="collaboration-hub-container">
        <div class="dialog-info">
            <label class="dialogTitle">{{ 'COLLABORATOR' | translate }}</label>
            <div class="crossButtonPosition">
                <button type="button" class="close-icon btn-close btn-close-white shadow-none" (click)="closeElement()"></button>
            </div>
        </div>
        <div class="table-responsive">
            <section class="small-table">
                <table mat-table [dataSource]="collabDataSource" class="compact-table collab-table pinned-table">

                    <ng-container matColumnDef="collaborator">
                        <th mat-header-cell *matHeaderCellDef> {{ 'COLLABORATOR' | translate }} </th>
                    </ng-container>

                    <ng-container matColumnDef="modifiedDate">
                        <th mat-header-cell *matHeaderCellDef> {{ 'MODIFIED_DATE' | translate }} </th>
                    </ng-container>

                    <ng-container matColumnDef="history">
                        <th mat-header-cell *matHeaderCellDef> {{ 'HISTORY' | translate }} </th>
                    </ng-container>

                    <ng-container matColumnDef="notes">
                        <th mat-header-cell *matHeaderCellDef> {{ 'NOTES' | translate }} </th>
                    </ng-container>

                    <!-- Pinned row header columns -->
                    <ng-container matColumnDef="decline-message">
                        <th mat-header-cell *matHeaderCellDef colspan="3">
                            <div class="decline-message" role="status">
                                <span>{{ 'COLLABORATION_ACCESS_DECLINED' | translate : { editor: pinnedRowDataSource.data[0]?.collaboratorName, notes: declineSummaryNotes } }}</span>
                            </div>
                        </th>
                    </ng-container>
                    <ng-container matColumnDef="decline-notes">
                        <th mat-header-cell *matHeaderCellDef>
                                <button mat-icon-button class="note-icon-btn"
                                    [attr.aria-label]="'NOTES' | translate"
                                    [matTooltip]="declineMessage"
                                    (click)="openNotesDialog(declineMessage)">
                                    <mat-icon>description</mat-icon>
                                </button>
                        </th>
                    </ng-container>
                    <ng-container matColumnDef="pinned-collaborator">
                        <th mat-header-cell *matHeaderCellDef> {{pinnedRowDataSource.data[0]?.collaboratorName}} </th>
                    </ng-container>

                    <ng-container matColumnDef="pinned-modifiedDate">
                        <th mat-header-cell *matHeaderCellDef>
                            @if(collaborationState === CollaborationState.Edit || collaborationState === CollaborationState.Locked) {
                                {{ 'COLLABORATION_EDITING_SINCE' | translate }}<br> {{ pinnedRowDataSource.data[0]?.modifiedDate | multilingualDate : 'dateTimeWithSeconds' }}
                            }
                            @else if(collaborationState === CollaborationState.Open) {
                                <button mat-raised-button
                                    color="primary"
                                    (click)="editCollabEstimate()"
                                    [disabled]="!currentCollaboratorData?.canEdit">
                                    {{ 'EDIT' | translate }}
                                </button>
                            }
                        </th>
                    </ng-container>

                    <ng-container matColumnDef="pinned-history">
                        <th mat-header-cell *matHeaderCellDef>
                            @if(collaborationState === CollaborationState.Edit) {
                                <button mat-raised-button
                                    color="primary"
                                    (click)="publishChanges()"
                                    [disabled]="!currentCollaboratorData?.canEdit">
                                    {{ 'PUBLISH' | translate }}
                                </button>
                                <button class="openCloseBtn"
                                    mat-raised-button
                                    color="primary"
                                    (click)="discardCollabChanges()">
                                    {{ 'DISCARD' | translate }}
                                </button>
                            }
                            @else if(collaborationState === CollaborationState.Locked && !isCurrentUserEditor) {
                                    <button mat-raised-button
                                        color="primary"
                                        (click)="requestEditorAccess()"
                                        [disabled]="!currentCollaboratorData?.canEdit || isChangeReqSent">
                                        {{ 'REQUEST_EDITOR_ACCESS' | translate }}
                                    </button>
                                <!-- @if(isChangeReqSent) {
                                    <i class="pending-request">{{ 'REQUEST_PENDING' | translate }}</i>
                                } -->
                            }
                        </th>
                    </ng-container>

                    <ng-container matColumnDef="pinned-notes">
                        <th mat-header-cell *matHeaderCellDef>
                            @if (collaborationState === CollaborationState.Locked && !isCurrentUserEditor && isChangeReqSent) {
                            <i class="pending-request">{{ 'REQUEST_PENDING' | translate }}</i>
                            }
                        </th>
                    
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-header-row *matHeaderRowDef="declineDisplayedColumns" [hidden]="!declineMessage" class="decline-row"></tr>
                    <tr mat-header-row *matHeaderRowDef="pinnedDisplayedColumns" class="pinned-row"></tr>
                </table>

                <div class="history-scroll">
                    <table mat-table [dataSource]="collabDataSource" class="compact-table collab-table history-table">
                        <ng-container matColumnDef="collaborator">
                            <td mat-cell *matCellDef="let element"> {{element.collaboratorName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="modifiedDate">
                            <td mat-cell *matCellDef="let element"> {{ element.modifiedDate | multilingualDate : 'dateTimeWithSeconds'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="history">
                            <td mat-cell *matCellDef="let element"> {{element.operation}} </td>
                        </ng-container>
                        <ng-container matColumnDef="notes">
                            <td mat-cell *matCellDef="let element">
                                <button mat-icon-button aria-label="File" (click)="openNotesDialog(element.modificationNotes)"
                                    class="note-icon-btn" tabindex="0">
                                    <mat-icon>description</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <!-- History rows scroll independently beneath the pinned collaboration rows. -->
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="data-row"></tr>
                    </table>
                </div>
            </section>
        </div>
    </mat-dialog-content>
</div>